import React from 'react';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { audienceNameAutoCompleteObservable$, audienceNameAutoCompleteInput$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const renderSuggestion = (suggestion) => (
   <div>
      {suggestion.text}
   </div>
);

const getSuggestionValue = (suggestion) => (console.log(suggestion));

const AudienceNameAutoSuggest = renderAutoSuggestWithOptions(
   audienceNameAutoCompleteObservable$,
   audienceNameAutoCompleteInput$,
   renderSuggestion,
   getSuggestionValue,
);

AudienceNameAutoSuggest.defaultProps = {
   selected: {
      id: null,
      text: '',
      display: '',
   },
   filterAudienceName: {
      id: null,
      text: '',
      display: '',
   },
   forceSelection: false,
   placeholder: 'Search Campaign Name...',
};

export default AudienceNameAutoSuggest;
